import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import CONFIG from "./config";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const AdminDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const res = location.state;
  let no_of_blogs;
  let no_of_events;
  let no_of_contacts;
  let no_of_enquiry;
  let no_of_job_enquiry;

  useEffect(() => {
    if (res) {
      Swal.fire({
        title: "Admin Login",
        text: "Welcome to Admin board",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });

      navigate(".", { replace: true, state: null });
    }
  }, [res, navigate]);

  const [blogLength, setBlogLength] = useState(0);
  const [eventLength, setEventLength] = useState(0);
  const [contactLength, setContactLength] = useState(0);
  const [enquiryLength, setEnquiryLength] = useState(0);
  const [jobEnquiryLength, setJobEnquiryLength] = useState(0);

  useEffect(() => {
    fetchBlogData();
    fetchEventData();
    fetchContactData();
    fetchEnquiryData();
    fetchJobEnquiryData();
  }, []);

  const fetchBlogData = async () => {
    try {
      const blogResponse = await axios.get(
        `${CONFIG.BASE_URL}/api/blogimages/images`
      );
      setBlogLength(blogResponse.data.length);
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };
  const fetchEventData = async () => {
    try {
      const eventResponse = await axios.get(
        `${CONFIG.BASE_URL}/api/images/images`
      );
      setEventLength(eventResponse.data.length);
    } catch (error) {
      console.error("Error fetching event data:", error);
    }
  };
  const fetchContactData = async () => {
    try {
      const contactResponse = await axios.get(
        `${CONFIG.BASE_URL}/Contact/submitforms`
      );
      setContactLength(contactResponse.data.contactsList.length);
    } catch (error) {
      console.error("Error fetching contact data:", error);
    }
  };
  const fetchEnquiryData = async () => {
    try {
      const enquiryResponse = await axios.get(
        `${CONFIG.BASE_URL}/BrAcademy/Enquiryform`
      );
      setEnquiryLength(enquiryResponse.data.enquirys.length);
    } catch (error) {
      console.error("Error fetching enquiry data:", error);
    }
  };
  const fetchJobEnquiryData = async () => {
    try {
      const jobEnquiryResponse = await axios.get(
        `${CONFIG.BASE_URL}/career/application/get/all`
      );
      setJobEnquiryLength(jobEnquiryResponse.data.application.length);
    } catch (error) {
      console.error("Error fetching job data:", error);
    }
  };

  if (blogLength < 10 && blogLength > 1) {
    no_of_blogs = "0" + blogLength;
  } else if (blogLength <= 0) {
    no_of_blogs = "00";
  } else {
    no_of_blogs = blogLength;
  }

  if (eventLength < 10 && eventLength > 1) {
    no_of_events = "0" + eventLength;
  } else if (eventLength <= 0) {
    no_of_events = "00";
  } else {
    no_of_events = eventLength;
  }

  if (contactLength < 10 && contactLength > 1) {
    no_of_contacts = "0" + contactLength;
  } else if (contactLength <= 0) {
    no_of_contacts = "00";
  } else {
    no_of_contacts = contactLength;
  }

  if (enquiryLength < 10 && enquiryLength > 1) {
    no_of_enquiry = "0" + enquiryLength;
  } else if (enquiryLength <= 0) {
    no_of_enquiry = "00";
  } else {
    no_of_enquiry = enquiryLength;
  }
  if (jobEnquiryLength < 10 && jobEnquiryLength > 1) {
    no_of_job_enquiry = "0" + jobEnquiryLength;
  } else if (jobEnquiryLength <= 0) {
    no_of_job_enquiry = "00";
  } else {
    no_of_job_enquiry = enquiryLength;
  }

  return (
    <div>
      <div
        className="custom-table-container wow fadeInUp"
        data-wow-delay="0.3s"
      >
        <div className="dashbaord_card_list">
          <div class="card radius-10 card_blue col-md-2 rounded-4 bg-grd-warning">
            <div class="card-body">
              <Link to="/blog-news">
                <div class="d-flex align-items-center">
                  <i className="bi-hurricane"></i>

                  <div class="flex-grow-1 ms-3">
                    <p class="mb-0 text-dark">No.of Blog</p>
                    <h5 class="mt-0 text-dark">{no_of_blogs}</h5>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div class="card radius-10 card_red col-md-2 rounded-4 bg-grd-warning">
            <div class="card-body">
              <Link to="/event">
                <div class="d-flex align-items-center">
                  <i className="bi-journal-bookmark-fill"></i>
                  <div class="flex-grow-1 ms-3">
                    <p class="mb-0 text-dark">No.of Event</p>
                    <h5 class="mt-0 text-dark">{no_of_events}</h5>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div class="card radius-10 card_green col-md-2 rounded-4 bg-grd-warning">
            <div class="card-body">
              <Link to="/contact">
                <div class="d-flex align-items-center">
                  <i className="bi-person-fill"></i>
                  <div class="flex-grow-1 ms-3">
                    <p class="mb-0 text-dark">No.of Contact</p>
                    <h5 class="mt-0 text-dark">{no_of_contacts}</h5>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div class="card radius-10 card_yellow col-md-2 rounded-4 bg-grd-warning">
            <div class="card-body">
              <Link to="/enquiry-form">
                <div class="d-flex align-items-center">
                  <i className="bi-receipt"></i>
                  <div class="flex-grow-1 ms-3">
                    <p class="mb-0 text-dark">No.of Enquiry</p>
                    <h5 class="mt-0 text-dark">{no_of_enquiry}</h5>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          <div class="card radius-10 card_purple col-md-2 rounded-4 bg-grd-warning">
            <div class="card-body">
              <Link to="/job-application-table">
                <div class="d-flex align-items-center">
                  <i className="bi-layout-text-sidebar"></i>
                  <div class="flex-grow-1 ms-3">
                    <p class="mb-0 text-dark">No.of Job Enquiry</p>
                    <h5 class="mt-0 text-dark">{no_of_job_enquiry}</h5>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
